<template>
	<div>
		<v-btn
				class="rounded-lg"
				color="success"
				depressed
				:large="$vuetify.breakpoint.mdAndUp"
				outlined
				@click="dialog = true"
		>
			<v-icon
					v-if="$vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xsOnly"
					:class="{
					'me-2': $vuetify.breakpoint.smAndUp,
					'ms-n1': $vuetify.breakpoint.smAndUp
				}"
			>
				mdi-plus
			</v-icon>
			<span v-if="$vuetify.breakpoint.smAndUp">New</span>
		</v-btn>

		<v-dialog v-model="dialog" content-class="rounded-xl" scrollable width="600px">
			<v-card class="position-relative" rounded="xl">
				<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
					<h6>New Product</h6>
					<v-btn
							class="mt-n1 me-n2"
							color="black"
							depressed
							icon
							@click="dialog = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="text-body-2">
					<v-row>
						<v-col>
							<v-select
									v-model="newProductTemplateId"
									class="rounded-lg"
									hide-details
									item-text="name"
									item-value="id"
									:items="templates"
									label="Product Type"
									outlined
							></v-select>
						</v-col>
					</v-row>
					<v-divider class="my-4 my-md-8"></v-divider>
					<v-row>
						<v-col>
							<div class="justify-end d-flex">
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="grey darken-1"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										outlined
										@click="
										() => {
											dialog = false;
											newProductTemplateId = null;
										}
									"
								>
									Cancel
								</v-btn>
								<v-btn
										class="rounded-lg"
										color="primary"
										depressed
										:disabled="!newProductTemplateId"
										:large="$vuetify.breakpoint.mdAndUp"
										@click="createProduct"
								>
									Next
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'NewProductModal',
	props: {
		productTemplates: {
			type: Array,
			default: () => []
		},
		venue: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			dialog: false,
			mq: { ...this.$vuetify.breakpoint },
			newProductTemplateId: null
		};
	},
	computed: {
		templates() {
			return [{ id: null, name: '- Select One -' }, ...this.productTemplates];
		}
	},
	created() {
	},
	methods: {
		createProduct() {
			this.modal = false;
			window.location.href = `/merchant-portal/${this.venue.id}/products/main/create-product?templateId=${this.newProductTemplateId}`;
		}
	}
};
</script>

<style lang="scss" scoped></style>
